import { TableRowItem } from '@components/components/table/table.interface';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'sp-table-body-row-extended',
  standalone: false,
  templateUrl: './table-body-row-extended.component.html',
  styleUrls: ['./table-body-row-extended.component.scss']

})
export class TableBodyRowExtendedComponent {
  @Input() expandableTable = null;
  @Input() expanded = null;
  @Input() query = null;
  @Input() basicQuery = null;
  @Input() cells = [];
  @Input() rows = [];
  constructor() {}
}